export default __webpack_public_path__ + "static/media/ideation1.5e1ac241.png";